(() => {
  function init(root) {
    if (root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const { signal } = controller;
    const track = root.querySelector('.ie-card-track');
    const prev = root.querySelector('[data-cards-prev]');
    const next = root.querySelector('[data-cards-next]');
    const syncArrows = () => {
      prev.disabled = track.scrollLeft < 3;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
      prev.parentElement.hidden = track.scrollWidth <= track.clientWidth + 3;
    };
    [prev, next].forEach((button, index) => button.addEventListener('click', () => {
      track.scrollBy({ left: (track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)) * (index ? 1 : -1), behavior: reduced.matches ? 'instant' : 'smooth' });
    }, { signal }));
    track.addEventListener('scroll', syncArrows, { passive: true, signal });
    const resize = new ResizeObserver(syncArrows); resize.observe(track); syncArrows();
    root.querySelectorAll('.ie-film').forEach(wrap => {
      const video = wrap.querySelector('video');
      const button = wrap.querySelector('button');
      let userPaused = false;
      let inView = false;
      const label = video.getAttribute('aria-label');
      const updateButton = () => {
        button.setAttribute('aria-label', `${video.paused ? 'Reproduzir' : 'Pausar'}: ${label}`);
        button.querySelector('span').textContent = video.paused ? '▶' : 'Ⅱ';
      };
      const play = () => video.play().catch(updateButton);
      button.hidden = false;
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      }, { signal });
      video.addEventListener('play', updateButton, { signal });
      video.addEventListener('pause', updateButton, { signal });
      video.addEventListener('error', () => { button.hidden = true; }, { signal });
      const observe = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        if (inView && !document.hidden && !reduced.matches && !userPaused && !video.ended) play();
        else if (!inView) video.pause();
      }, { threshold: .25 });
      observe.observe(video);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (inView && !userPaused && !reduced.matches && !video.ended) play();
      }, { signal });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); }, { signal });
      signal.addEventListener('abort', () => { observe.disconnect(); video.pause(); }, { once: true });
      updateButton();
    });
    const modes = root.querySelectorAll('button[data-mode-image]');
    const modeImage = root.querySelector('img[data-mode-image]');
    modes.forEach(button => button.addEventListener('click', () => {
      modes.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      modeImage.src = button.dataset.modeImage;
      modeImage.alt = `iPhone Duo — ${button.textContent.trim()}`;
      root.querySelector('[data-mode-kicker]').textContent = button.textContent;
      root.querySelector('h3[data-mode-title]').textContent = button.dataset.modeTitle;
      root.querySelector('p[data-mode-description]').textContent = button.dataset.modeDescription;
    }, { signal }));
    if (modeImage) root.querySelector('.ie-modes-copy').setAttribute('aria-live', 'polite');
    document.addEventListener('shopify:section:unload', e => {
      if (e.target.contains(root)) { resize.disconnect(); controller.abort(); }
    }, { signal });
  }
  document.querySelectorAll('.ie').forEach(init);
  if (!window.isafeEditorialBound) {
    window.isafeEditorialBound = true;
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.ie').forEach(init));
  }
})();
